module.exports = __webpack_public_path__ + "img/ch80.5fcb24d8.jpg";